import React, { useCallback, useState } from 'react';

import { Modal, Button } from '../..';
import { URLS, USER_ROLES } from '../../../constants/constants';

import styles from './index.module.css';

export const useConfigureBillingModal = ({
  title,
  description,
  onConfirm,
  onCancel: onCancelProp,
  createHO,
  loginAsDifferentRole,
  navigate,
}) => {
  const [visibleModal, setModalVisible] = useState(false);
  const [createdClinic, setCreatedClinic] = useState(null);
  const [loading, setLoading] = useState(false);

  const onCancel = useCallback(() => {
    setModalVisible(false);
    if (onCancelProp) {
      onCancelProp();
    } else if (navigate) {
      navigate.push(URLS.HEALTH_ORGANIZATIONS);
    }
  }, [onCancelProp, navigate]);

  const handleConfirm = useCallback(async () => {
    try {
      if (onConfirm) {
        await onConfirm(createdClinic);
      } else if (createdClinic && loginAsDifferentRole && navigate) {
        loginAsDifferentRole({
          organizationId: createdClinic.id,
          organizationName: createdClinic.name,
          role: USER_ROLES.HO_ADMIN,
          parentOrgId: createdClinic.parentOrgId,
          Navigation: navigate,
          redirectTo: URLS.PREFERENCES,
          billingSetupOnly: true,
          scrollToBilling: true,
        });
      }
      setModalVisible(false);
    } catch {
      setModalVisible(false);
    }
  }, [onConfirm, createdClinic, loginAsDifferentRole, navigate]);

  const submitCreateClinic = useCallback(
    async (values) => {
      if (!createHO || !navigate) return;

      setLoading(true);
      try {
        const data = await createHO(values, navigate, { skipNavigate: true });
        if (data) {
          setCreatedClinic(data);
          setModalVisible(true);
        }
      } finally {
        setLoading(false);
      }
    },
    [createHO, navigate],
  );

  return {
    Modal: (
      <Modal
        visible={visibleModal}
        onCancel={onCancel}
        closable
        width={620}
        myClassName={styles.configureBillingModal}
        title={
          <div className={styles.modalTitle}>
            <div>{title}</div>
          </div>
        }
      >
        <div className={styles.modalContent}>
          <p className={styles.modalPrimaryText}>{description}</p>
          <div className={styles.modalBtns}>
            <div>
              <Button myClassName={styles.navigationBtn} onClick={onCancel} disabled={loading}>
                Cancel
              </Button>
            </div>
            <div>
              <Button
                myClassName={styles.navigationBtn}
                onClick={handleConfirm}
                disabled={loading}
                loading={loading}
              >
                Ok
              </Button>
            </div>
          </div>
        </div>
      </Modal>
    ),
    setConfigureBillingModalVisible: setModalVisible,
    submitCreateClinic,
    creating: loading,
  };
};
